import { render, staticRenderFns } from "./FlightSidebar.vue?vue&type=template&id=4bef4ae7&scoped=true"
import script from "./FlightSidebar.vue?vue&type=script&lang=js"
export * from "./FlightSidebar.vue?vue&type=script&lang=js"
import style0 from "./FlightSidebar.vue?vue&type=style&index=0&id=4bef4ae7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bef4ae7",
  null
  
)

export default component.exports